export const config = {
  photoBlock: {
    path: '/images/consultation/cto-eugene.webp',
    width: 430,
    height: 460,
    alt: 'Modsen CTO',
    title: 'Modsen CTO',
  },
  formBlock: {
    title: 'Schedule a free expert consultation',
    subtitle:
      'Our experts will qualitatively evaluate your project idea and provide the most effective tools for its implementation.',
    personName: 'Eugene Kalugin,',
    personPosition: 'CTO',
    submitText: 'Thanks, we’ve got it!',
  },
  decorativeItems: [
    {
      path: '/images/atom-figures-3.webp',
      width: 523,
      height: 929,
      alt: '',
      position: {
        top: -300,
        right: -200,
      },
    },
  ],
}
